/* tslint:disable */
/**
 * AB Service
 * AB testing service. Provides weighted AB testing info for features.
 *
 * OpenAPI spec version: 1.1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as querystring from "querystring";
import * as url from "url";
import * as isomorphicFetch from "isomorphic-fetch";
import * as assign from "core-js/library/fn/object/assign";
var BASE_PATH = "https://api-private.east.zocdoccloud.net";
var BaseAPI = /** @class */ (function () {
    function BaseAPI(fetch, basePath) {
        if (fetch === void 0) { fetch = isomorphicFetch; }
        if (basePath === void 0) { basePath = BASE_PATH; }
        this.basePath = basePath;
        this.fetch = fetch;
    }
    return BaseAPI;
}());
export { BaseAPI };
/**
 * DefaultApi - fetch parameter creator
 */
export var DefaultApiFetchParamCreactor = {
    /**
     * Gets the data file for a project.
     * Given a project id, returns the data file of experiment weights.
     * @param projectName Name of the project containing the experiments to be requested
     */
    getDatafile: function (params) {
        // verify required parameter "projectName" is set
        if (params["projectName"] == null) {
            throw new Error("Missing required parameter projectName when calling getDatafile");
        }
        var baseUrl = "/ab/v1/projects/{projectName}/datafile"
            .replace("{" + "projectName" + "}", "" + params.projectName);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = { method: "GET" };
        var contentTypeHeader;
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     * Gets the data file version for a project.
     * Given a project id, returns the data file version.
     * @param projectName Name of the project you want the current version of
     */
    getDatafileVersion: function (params) {
        // verify required parameter "projectName" is set
        if (params["projectName"] == null) {
            throw new Error("Missing required parameter projectName when calling getDatafileVersion");
        }
        var baseUrl = "/ab/v1/projects/{projectName}/datafile-version"
            .replace("{" + "projectName" + "}", "" + params.projectName);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = { method: "GET" };
        var contentTypeHeader;
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     * Gets the experiments for a given project and user.
     * Given a project id and a user id, return the experiments and assignments.
     * @param projectName Name of the project containing the experiments to be requested
     * @param visitorId
     * @param requestOriginUrl
     * @param clientUserAgent A clientUserAgent sent from PWA to override the node web server user-agent
     * @param userAgent This should be forwarded from the originating user (i.e. a browser, a mobile device, etc.)
     * @param attributes
     */
    getProjectExperiments: function (params) {
        // verify required parameter "projectName" is set
        if (params["projectName"] == null) {
            throw new Error("Missing required parameter projectName when calling getProjectExperiments");
        }
        // verify required parameter "visitorId" is set
        if (params["visitorId"] == null) {
            throw new Error("Missing required parameter visitorId when calling getProjectExperiments");
        }
        // verify required parameter "requestOriginUrl" is set
        if (params["requestOriginUrl"] == null) {
            throw new Error("Missing required parameter requestOriginUrl when calling getProjectExperiments");
        }
        var baseUrl = "/ab/v1/projects/{projectName}/experiments"
            .replace("{" + "projectName" + "}", "" + params.projectName);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "visitorId": params.visitorId,
            "requestOriginUrl": params.requestOriginUrl,
            "clientUserAgent": params.clientUserAgent,
            "attributes": params.attributes,
        });
        var fetchOptions = { method: "GET" };
        var contentTypeHeader;
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     * Gets the data file for a project.
     * Given a project id, returns the data file of experiment weights.
     * @param projectId The
     */
    getRawDatafile: function (params) {
        // verify required parameter "projectId" is set
        if (params["projectId"] == null) {
            throw new Error("Missing required parameter projectId when calling getRawDatafile");
        }
        var baseUrl = "/ab/v1/projects/{projectId}/rawdatafile"
            .replace("{" + "projectId" + "}", "" + params.projectId);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = { method: "GET" };
        var contentTypeHeader;
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     * An endpoint for logging the results of assignments to datalake. Useful for the mobile apps, where the coin flip is performed elsewhere
     * Given info about assignments, log them to the Datalake.
     * @param assignmentData
     */
    logAssignments: function (params) {
        var baseUrl = "/ab/v1/assignments/logging";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = { method: "POST" };
        var contentTypeHeader;
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["assignmentData"]) {
            fetchOptions.body = JSON.stringify(params["assignmentData"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     * An endpoint for logging the conversion events to datalake. Useful for the mobile apps, where the coin flip is performed elsewhere
     * @param conversionData
     */
    logConversions: function (params) {
        var baseUrl = "/ab/v1/conversions/logging";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = { method: "POST" };
        var contentTypeHeader;
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["conversionData"]) {
            fetchOptions.body = JSON.stringify(params["conversionData"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     * Sets a new data file for a project
     * @param update
     */
    postLegacy: function (params) {
        var baseUrl = "/ab-internal/v1/datafile";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = { method: "POST" };
        var contentTypeHeader;
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["update"]) {
            fetchOptions.body = JSON.stringify(params["update"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     * Gets the assignments for a list of experiments for a user.
     * Given a list of experiment ids, a user id, and attribues, return the experiment assignments.
     * @param assignmentData
     * @param accept Can be specified from the client if they want the response to be simple
     */
    setAssignments: function (params) {
        var baseUrl = "/ab/v1/assignments";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = { method: "POST" };
        var contentTypeHeader;
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["assignmentData"]) {
            fetchOptions.body = JSON.stringify(params["assignmentData"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     * Gets the assignments for a list of experiments for a user.
     * Given a list of experiment ids, a user id, and attribues, return the experiment assignments.
     * @param assignmentData
     * @param accept Can be specified from the client if they want the response to be simple
     */
    setAssignmentsV2: function (params) {
        var baseUrl = "/ab/v2/assignments";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = { method: "POST" };
        var contentTypeHeader;
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["assignmentData"]) {
            fetchOptions.body = JSON.stringify(params["assignmentData"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     * Gets the assignments for a list of seo experiments for a particular url.
     * Given a list of experiment ids and url, return the seo experiment assignments.
     * @param assignmentData
     * @param accept Can be specified from the client if they want the response to be simple
     */
    setSEOAssignments: function (params) {
        var baseUrl = "/ab/v1/seo-testing";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = { method: "POST" };
        var contentTypeHeader;
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["assignmentData"]) {
            fetchOptions.body = JSON.stringify(params["assignmentData"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     * Records conversion events.
     * @param conversionData
     */
    trackConversion: function (params) {
        var baseUrl = "/ab/v1/conversions";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = { method: "POST" };
        var contentTypeHeader;
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["conversionData"]) {
            fetchOptions.body = JSON.stringify(params["conversionData"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     * Records conversion events.
     * @param conversionData
     */
    trackConversionV2: function (params) {
        var baseUrl = "/ab/v2/conversions";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = { method: "POST" };
        var contentTypeHeader;
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["conversionData"]) {
            fetchOptions.body = JSON.stringify(params["conversionData"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     * Webhook endpoint for optimizely to refresh the datafile.
     * @param projectId Optimizely project id.
     * @param timestamp Timestamp of the datafile change.
     * @param event Optimizely event type, in this case will be project.datafile_updated.
     * @param data
     */
    updateDatafile: function (params) {
        var baseUrl = "/ab/v1/datafile";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = { method: "POST" };
        var contentTypeHeader;
        contentTypeHeader = { "Content-Type": "application/x-www-form-urlencoded" };
        fetchOptions.body = querystring.stringify({
            "project_id": params.projectId,
            "timestamp": params.timestamp,
            "event": params.event,
            "data": params.data,
        });
        if (contentTypeHeader) {
            fetchOptions.headers = contentTypeHeader;
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * DefaultApi - functional programming interface
 */
export var DefaultApiFp = {
    /**
     * Gets the data file for a project.
     * Given a project id, returns the data file of experiment weights.
     * @param projectName Name of the project containing the experiments to be requested
     */
    getDatafile: function (params) {
        var fetchArgs = DefaultApiFetchParamCreactor.getDatafile(params);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     * Gets the data file version for a project.
     * Given a project id, returns the data file version.
     * @param projectName Name of the project you want the current version of
     */
    getDatafileVersion: function (params) {
        var fetchArgs = DefaultApiFetchParamCreactor.getDatafileVersion(params);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     * Gets the experiments for a given project and user.
     * Given a project id and a user id, return the experiments and assignments.
     * @param projectName Name of the project containing the experiments to be requested
     * @param visitorId
     * @param requestOriginUrl
     * @param clientUserAgent A clientUserAgent sent from PWA to override the node web server user-agent
     * @param userAgent This should be forwarded from the originating user (i.e. a browser, a mobile device, etc.)
     * @param attributes
     */
    getProjectExperiments: function (params) {
        var fetchArgs = DefaultApiFetchParamCreactor.getProjectExperiments(params);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     * Gets the data file for a project.
     * Given a project id, returns the data file of experiment weights.
     * @param projectId The
     */
    getRawDatafile: function (params) {
        var fetchArgs = DefaultApiFetchParamCreactor.getRawDatafile(params);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     * An endpoint for logging the results of assignments to datalake. Useful for the mobile apps, where the coin flip is performed elsewhere
     * Given info about assignments, log them to the Datalake.
     * @param assignmentData
     */
    logAssignments: function (params) {
        var fetchArgs = DefaultApiFetchParamCreactor.logAssignments(params);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     * An endpoint for logging the conversion events to datalake. Useful for the mobile apps, where the coin flip is performed elsewhere
     * @param conversionData
     */
    logConversions: function (params) {
        var fetchArgs = DefaultApiFetchParamCreactor.logConversions(params);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     * Sets a new data file for a project
     * @param update
     */
    postLegacy: function (params) {
        var fetchArgs = DefaultApiFetchParamCreactor.postLegacy(params);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     * Gets the assignments for a list of experiments for a user.
     * Given a list of experiment ids, a user id, and attribues, return the experiment assignments.
     * @param assignmentData
     * @param accept Can be specified from the client if they want the response to be simple
     */
    setAssignments: function (params) {
        var fetchArgs = DefaultApiFetchParamCreactor.setAssignments(params);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     * Gets the assignments for a list of experiments for a user.
     * Given a list of experiment ids, a user id, and attribues, return the experiment assignments.
     * @param assignmentData
     * @param accept Can be specified from the client if they want the response to be simple
     */
    setAssignmentsV2: function (params) {
        var fetchArgs = DefaultApiFetchParamCreactor.setAssignmentsV2(params);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     * Gets the assignments for a list of seo experiments for a particular url.
     * Given a list of experiment ids and url, return the seo experiment assignments.
     * @param assignmentData
     * @param accept Can be specified from the client if they want the response to be simple
     */
    setSEOAssignments: function (params) {
        var fetchArgs = DefaultApiFetchParamCreactor.setSEOAssignments(params);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     * Records conversion events.
     * @param conversionData
     */
    trackConversion: function (params) {
        var fetchArgs = DefaultApiFetchParamCreactor.trackConversion(params);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     * Records conversion events.
     * @param conversionData
     */
    trackConversionV2: function (params) {
        var fetchArgs = DefaultApiFetchParamCreactor.trackConversionV2(params);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     * Webhook endpoint for optimizely to refresh the datafile.
     * @param projectId Optimizely project id.
     * @param timestamp Timestamp of the datafile change.
     * @param event Optimizely event type, in this case will be project.datafile_updated.
     * @param data
     */
    updateDatafile: function (params) {
        var fetchArgs = DefaultApiFetchParamCreactor.updateDatafile(params);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * DefaultApi - object-oriented interface
 */
var DefaultApi = /** @class */ (function (_super) {
    __extends(DefaultApi, _super);
    function DefaultApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Gets the data file for a project.
     * Given a project id, returns the data file of experiment weights.
     * @param projectName Name of the project containing the experiments to be requested
     */
    DefaultApi.prototype.getDatafile = function (params) {
        return DefaultApiFp.getDatafile(params)(this.fetch, this.basePath);
    };
    /**
     * Gets the data file version for a project.
     * Given a project id, returns the data file version.
     * @param projectName Name of the project you want the current version of
     */
    DefaultApi.prototype.getDatafileVersion = function (params) {
        return DefaultApiFp.getDatafileVersion(params)(this.fetch, this.basePath);
    };
    /**
     * Gets the experiments for a given project and user.
     * Given a project id and a user id, return the experiments and assignments.
     * @param projectName Name of the project containing the experiments to be requested
     * @param visitorId
     * @param requestOriginUrl
     * @param clientUserAgent A clientUserAgent sent from PWA to override the node web server user-agent
     * @param userAgent This should be forwarded from the originating user (i.e. a browser, a mobile device, etc.)
     * @param attributes
     */
    DefaultApi.prototype.getProjectExperiments = function (params) {
        return DefaultApiFp.getProjectExperiments(params)(this.fetch, this.basePath);
    };
    /**
     * Gets the data file for a project.
     * Given a project id, returns the data file of experiment weights.
     * @param projectId The
     */
    DefaultApi.prototype.getRawDatafile = function (params) {
        return DefaultApiFp.getRawDatafile(params)(this.fetch, this.basePath);
    };
    /**
     * An endpoint for logging the results of assignments to datalake. Useful for the mobile apps, where the coin flip is performed elsewhere
     * Given info about assignments, log them to the Datalake.
     * @param assignmentData
     */
    DefaultApi.prototype.logAssignments = function (params) {
        return DefaultApiFp.logAssignments(params)(this.fetch, this.basePath);
    };
    /**
     * An endpoint for logging the conversion events to datalake. Useful for the mobile apps, where the coin flip is performed elsewhere
     * @param conversionData
     */
    DefaultApi.prototype.logConversions = function (params) {
        return DefaultApiFp.logConversions(params)(this.fetch, this.basePath);
    };
    /**
     * Sets a new data file for a project
     * @param update
     */
    DefaultApi.prototype.postLegacy = function (params) {
        return DefaultApiFp.postLegacy(params)(this.fetch, this.basePath);
    };
    /**
     * Gets the assignments for a list of experiments for a user.
     * Given a list of experiment ids, a user id, and attribues, return the experiment assignments.
     * @param assignmentData
     * @param accept Can be specified from the client if they want the response to be simple
     */
    DefaultApi.prototype.setAssignments = function (params) {
        return DefaultApiFp.setAssignments(params)(this.fetch, this.basePath);
    };
    /**
     * Gets the assignments for a list of experiments for a user.
     * Given a list of experiment ids, a user id, and attribues, return the experiment assignments.
     * @param assignmentData
     * @param accept Can be specified from the client if they want the response to be simple
     */
    DefaultApi.prototype.setAssignmentsV2 = function (params) {
        return DefaultApiFp.setAssignmentsV2(params)(this.fetch, this.basePath);
    };
    /**
     * Gets the assignments for a list of seo experiments for a particular url.
     * Given a list of experiment ids and url, return the seo experiment assignments.
     * @param assignmentData
     * @param accept Can be specified from the client if they want the response to be simple
     */
    DefaultApi.prototype.setSEOAssignments = function (params) {
        return DefaultApiFp.setSEOAssignments(params)(this.fetch, this.basePath);
    };
    /**
     * Records conversion events.
     * @param conversionData
     */
    DefaultApi.prototype.trackConversion = function (params) {
        return DefaultApiFp.trackConversion(params)(this.fetch, this.basePath);
    };
    /**
     * Records conversion events.
     * @param conversionData
     */
    DefaultApi.prototype.trackConversionV2 = function (params) {
        return DefaultApiFp.trackConversionV2(params)(this.fetch, this.basePath);
    };
    /**
     * Webhook endpoint for optimizely to refresh the datafile.
     * @param projectId Optimizely project id.
     * @param timestamp Timestamp of the datafile change.
     * @param event Optimizely event type, in this case will be project.datafile_updated.
     * @param data
     */
    DefaultApi.prototype.updateDatafile = function (params) {
        return DefaultApiFp.updateDatafile(params)(this.fetch, this.basePath);
    };
    return DefaultApi;
}(BaseAPI));
export { DefaultApi };
;
/**
 * DefaultApi - factory interface
 */
export var DefaultApiFactory = function (fetch, basePath) {
    return {
        /**
         * Gets the data file for a project.
         * Given a project id, returns the data file of experiment weights.
         * @param projectName Name of the project containing the experiments to be requested
         */
        getDatafile: function (params) {
            return DefaultApiFp.getDatafile(params)(fetch, basePath);
        },
        /**
         * Gets the data file version for a project.
         * Given a project id, returns the data file version.
         * @param projectName Name of the project you want the current version of
         */
        getDatafileVersion: function (params) {
            return DefaultApiFp.getDatafileVersion(params)(fetch, basePath);
        },
        /**
         * Gets the experiments for a given project and user.
         * Given a project id and a user id, return the experiments and assignments.
         * @param projectName Name of the project containing the experiments to be requested
         * @param visitorId
         * @param requestOriginUrl
         * @param clientUserAgent A clientUserAgent sent from PWA to override the node web server user-agent
         * @param userAgent This should be forwarded from the originating user (i.e. a browser, a mobile device, etc.)
         * @param attributes
         */
        getProjectExperiments: function (params) {
            return DefaultApiFp.getProjectExperiments(params)(fetch, basePath);
        },
        /**
         * Gets the data file for a project.
         * Given a project id, returns the data file of experiment weights.
         * @param projectId The
         */
        getRawDatafile: function (params) {
            return DefaultApiFp.getRawDatafile(params)(fetch, basePath);
        },
        /**
         * An endpoint for logging the results of assignments to datalake. Useful for the mobile apps, where the coin flip is performed elsewhere
         * Given info about assignments, log them to the Datalake.
         * @param assignmentData
         */
        logAssignments: function (params) {
            return DefaultApiFp.logAssignments(params)(fetch, basePath);
        },
        /**
         * An endpoint for logging the conversion events to datalake. Useful for the mobile apps, where the coin flip is performed elsewhere
         * @param conversionData
         */
        logConversions: function (params) {
            return DefaultApiFp.logConversions(params)(fetch, basePath);
        },
        /**
         * Sets a new data file for a project
         * @param update
         */
        postLegacy: function (params) {
            return DefaultApiFp.postLegacy(params)(fetch, basePath);
        },
        /**
         * Gets the assignments for a list of experiments for a user.
         * Given a list of experiment ids, a user id, and attribues, return the experiment assignments.
         * @param assignmentData
         * @param accept Can be specified from the client if they want the response to be simple
         */
        setAssignments: function (params) {
            return DefaultApiFp.setAssignments(params)(fetch, basePath);
        },
        /**
         * Gets the assignments for a list of experiments for a user.
         * Given a list of experiment ids, a user id, and attribues, return the experiment assignments.
         * @param assignmentData
         * @param accept Can be specified from the client if they want the response to be simple
         */
        setAssignmentsV2: function (params) {
            return DefaultApiFp.setAssignmentsV2(params)(fetch, basePath);
        },
        /**
         * Gets the assignments for a list of seo experiments for a particular url.
         * Given a list of experiment ids and url, return the seo experiment assignments.
         * @param assignmentData
         * @param accept Can be specified from the client if they want the response to be simple
         */
        setSEOAssignments: function (params) {
            return DefaultApiFp.setSEOAssignments(params)(fetch, basePath);
        },
        /**
         * Records conversion events.
         * @param conversionData
         */
        trackConversion: function (params) {
            return DefaultApiFp.trackConversion(params)(fetch, basePath);
        },
        /**
         * Records conversion events.
         * @param conversionData
         */
        trackConversionV2: function (params) {
            return DefaultApiFp.trackConversionV2(params)(fetch, basePath);
        },
        /**
         * Webhook endpoint for optimizely to refresh the datafile.
         * @param projectId Optimizely project id.
         * @param timestamp Timestamp of the datafile change.
         * @param event Optimizely event type, in this case will be project.datafile_updated.
         * @param data
         */
        updateDatafile: function (params) {
            return DefaultApiFp.updateDatafile(params)(fetch, basePath);
        },
    };
};
